export const nodeConsumableActions = {
  INSTALL: 'INSTALL',
  SWAP: 'SWAP',
  REMOVE: 'REMOVE',
}
